export default {
    namespaced: true,
    state: {
        colors: [],
        errors: {
            getColors: ''
        }
    },
    getters: {
        nameColor: state => id => {
            const color = state.colors.find(color => {
                return color.ColorID === id
            })

            return color ? color.Name : ''
        }
    },
    mutations: {
        SET_COLORS(state, payload) {
            state.colors = payload
        },
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        async getColors({ commit }) {
            commit('SET_ERRORS', {
                key: 'getColors',
                val: ''
            })

            const url = '/public/dict/colors'

            try {
                const resp = await this.$axios.get(url).then(res => {
                    return res.data
                })

                commit('SET_COLORS', resp)
            } catch (e) {
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getColors',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getColors',
                        val: 'Ошибка'
                    })
                }
            }
        }
    }
}
